import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _UBLInvoice } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";

type UBLInvoice = {
    IDUBLInvoice: number;
    IssueDate: any;
    [Key: string]: any;
}

interface Props {
    ubl: UBLInvoice;
    label?: string;
    idSelect: number | null;
    onChange: Function;
}
export const SelectAvailableTaxEntityConsecutive = ({ ubl, idSelect, label, onChange }: Props) => {

    const { lista, setLista, instance } = useDataBean(_UBLInvoice);
    const [id, setId] = useState<number>(NaN);

    useEffect(() => {
        if (ubl.IDUBLInvoice && ubl.IssueDate) {
            instance.getAvailableTaxEntityConsecutive(ubl.IDUBLInvoice, ubl.IssueDate).then(
                (resp: any) => {
                    setLista(resp);
                    if (resp.length > 0) {
                        onChange(resp[0].DataBeanProperties.IDTaxEntityConsecutive);
                        setId(resp[0].DataBeanProperties.IDTaxEntityConsecutive);
                    }
                }
            ).catch(err => { toast.error(err) })
        }
    }, [ubl.IDUBLInvoice])

    useEffect(() => {
        if (idSelect != id) {
            setId(idSelect);
        }
    }, [idSelect])

    const setValue = (e: any) => {
        setId(e);
        onChange(e);
    }

    return (
        <>
            <label>{label ?? 'Numeración'}</label>
            <select className="form-select" value={id} onChange={(e) => {
                const valor = e.target.value ? parseInt(e.target.value) : null
                setValue(valor)
            }}>
                <option value={""}>...</option>
                {lista.map((item: any) => {
                    return (
                        <option key={item.DataBeanProperties.IDTaxEntityConsecutive} value={item.DataBeanProperties.IDTaxEntityConsecutive}>{item.DataBeanProperties.TaxEntityConsecutiveName}</option>
                    )
                })}
            </select>
        </>
    )
}